const translationEn = {
  message: {
    button: {
      add_vehicle: 'Add Vehicle',
      delete_photo: 'Delete photo',
      hide: 'Hide',
      save: 'Save'
    },

    error: {
      brand: 'Please enter vehicle manufacturer',
      description: 'Please enter vehicle description',
      model: 'Please enter vehicle model',
      price: 'Please enter vehicle price',
      saving_failed: 'Could not save vehicle',
      year: 'Please enter vehicle manufacturing year'
    },

    form: {
      brand: 'Brand',
      description: 'Description',
      model: 'Model',
      photo: 'Photo',
      price: 'Price',
      year: 'Year',
      placeholder: {
        description: 'Enter car description ...'
      }
    },

    notification: {
      created: 'Vehicle created',
      create_failed: 'Could not create vehicle',
      create_not_valid: 'Vehicle is not valid',
      photo_deleted: 'Photo Deleted: {file_name}',
      photo_not_deleted: 'Could not delete: {file_name}',
      photo_upload_failed: 'Could not save photo',
      photo_uploaded: 'Photo Saved',
      saved: 'Saved',
      status_not_set: 'Unable to set status',
      status_set: 'Status {status_val} was set'
    },

    status: {
      HOT: 'Hot',
      AVAILABLE: 'Available',
      CREATED: 'New',
      SOLD: 'Sold',
      HIDDEN: 'Hidden',
      DELETED: 'Deleted'
    },

    title: {
      menu: 'Menu',

      main: {
        about_us: 'About Us',
        contacts: 'Contacts',
        home: 'Home',
        media: 'Media'
      },

      site: {
        blog: 'Blog',
        car_detail: 'Vehicle Detail',
        club: 'Club',
        garage: 'Garage',
        hot_offers: 'Hot Offers',
        our_cars: 'Our Cars',
        photo_admin: 'Photo Admin',
        services: 'Services'
      },

      admin: {
        add_new_vehicle: 'Add New Vehicle',
        icons: {
          delete: 'Delete vehicle',
          edit: 'Edit vehicle',
          hide: 'Hide vehicle',
          hot_status_HOT: 'Delete Hot Offer status',
          hot_status_AVAILABLE: 'Mark as Hot Offer',
          make_available: 'Make vehicle available',
          sell: 'Mark vehicle as sold',
          update_photos: 'Update vehicle photos'
        },
        rec_status: 'Status'
      }
    },

    text: {
      cars: {
        no_cars: 'Unfortunately there are no cars available for displaying at this moment. Come back later ;-)'
      },
      home: {
        intro: 'Dear old timers enthusiasts, you can find a collection of a few cars from our collection that we are ready to make available for purchase.'
      }
    }
  }
}

const translationCs = {
  message: {
    button: {
      add_vehicle: 'Přidat Vozidlo',
      delete_photo: 'Smazat fotku',
      hide: 'Skrýt',
      save: 'Uložit'
    },

    error: {
      brand: 'Zadejte prosím výrobce vozidla',
      description: 'Zadejte prosím popis vozidla',
      model: 'Zadejte prosím model vozidla',
      price: 'Zadejte prosím cenu vozidla',
      saving_failed: 'Ukládání se nepovedlo',
      year: 'Zadejte prosím rok výroby vozidla'
    },

    form: {
      brand: 'Výrobce',
      description: 'Popisek',
      model: 'Model',
      photo: 'Fotka',
      price: 'Cena',
      year: 'Rok výroby',
      placeholder: {
        description: 'Zadejte popisek vozidla ...'
      }
    },

    notification: {
      created: 'Vozidlo vytvořeno',
      create_failed: 'Uložení vozidla se nepovedlo',
      create_not_valid: 'Vozidlo není správně zadáno',
      photo_deleted: 'Fotka smazána: {file_name}',
      photo_not_deleted: 'Nepovedlo se smazat fotku: {file_name}',
      photo_upload_failed: 'Uložení fotky se nepodařilo',
      photo_uploaded: 'Fotka uložena',
      saved: 'Uloženo',
      status_not_set: 'Status se nepovedlo nastavit',
      status_set: 'Status {status_val} úspěšně nastaven'
    },

    status: {
      HOT: 'Novinka',
      AVAILABLE: 'Dostupné',
      CREATED: 'Nové',
      SOLD: 'Prodáno',
      HIDDEN: 'Skryté',
      DELETED: 'Smazáno'
    },

    title: {
      menu: 'Menu',

      main: {
        about_us: 'O Nás',
        contacts: 'Kontakty',
        home: 'Domů',
        media: 'Média'
      },

      site: {
        blog: 'Blog',
        car_detail: 'Detail Vozidla',
        club: 'Klub',
        garage: 'Garáž',
        hot_offers: 'Aktuální Nabídka',
        our_cars: 'Naše Auta',
        photo_admin: 'Photo Admin',
        services: 'Služby'
      },

      admin: {
        add_new_vehicle: 'Přidat Nové Vozidlo',
        icons: {
          delete: 'Smazat vozidlo',
          edit: 'Editovat vozidlo',
          hide: 'Skrýt vozidlo',
          hot_status_HOT: 'Smazat status Novinka',
          hot_status_AVAILABLE: 'Nastavit status Novinka',
          make_available: 'Nastavit jako dostupné',
          sell: 'Označit vozidlo jako prodané',
          update_photos: 'Editovat fotografie vozidla'
        },
        rec_status: 'Stav'
      }
    },

    text: {
      cars: {
        no_cars: 'Momentálně bohužel nejsou k dispozici žádná auta k zobrazení. Zkuste se stavit později ;-)'
      },
      home: {
        intro: 'Vážení milovníci historických vozidel, na našich stránkách Vám občas nabídneme nějaká vozidla, která můžeme uvolnit z naší sbírky.'
      }
    }
  }
}

export default {
  cs: translationCs,
  en: translationEn
}



// WEBPACK FOOTER //
// ./src/services/i18n.js